import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=b58b33be&scoped=true&lang=pug"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=b58b33be&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58b33be",
  null
  
)

export default component.exports